<template>
  <div class="about-chapter-edit">
    <div v-if="!editContainerShown">
      <v-btn
          v-if="chapterAbout.canEdit && !!chapterAbout.message"
          data-qe-id="about_edit_dialog_edit__btn"
          icon
          @click="resetAboutMessage">
        <i class="fas fa-pencil-alt"></i>
      </v-btn>
      <v-btn
          v-if="chapterAbout && !chapterAbout.message && chapterAbout.canEdit && (chapterAbout.message === null || chapterAbout.message.length === 0)"
          class="about-chapter-edit__add-message"
          color="ypo_blue white--text"
          data-qe-id="add_about_message_btn"
          @click="showEditContainer">
        {{ addBtnMessage }}
      </v-btn>
    </div>

    <v-card v-else>
      <div class="about-chapter-edit__title">
        <h2 data-qe-id="about_edit_dialog_title"> {{ communityCommonConstant.about.TITLE }}</h2>
      </div>
      <v-card-text pl-0 pr-0>
        <v-container
            pl-0
            pr-0
            pt-0>
          <v-layout wrap>
            <v-flex class="about-chapter-edit__image" xs12>
              <div v-if="!!imageUrl" class="about-chapter-edit__image-frame">
                <div class="about-chapter-edit__image-container">
                  <v-img
                      :src="imageUrl"
                      aspect-ratio="1.75"
                      contain
                      data-qe-id="about_edit_dialog_about_image"
                      max-height="150"></v-img>
                  <v-btn
                      class="about-chapter-edit__image-remove"
                      data-qe-id="remove_about_image_btn"
                      fab
                      flat
                      small
                      @click="removePostImage()">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-flex>
            <v-flex sm12>
              <ck-editor
                  v-model="newAboutMessage.message"
                  height="350"
                  :can-upload-image="!imageUrl"
                  :editor-id="ckEditorId"
                  :editor-type="ckEditorType.BASIC"
                  :input-filter-for-image="inputFilterForImageFile"
                  :update-image-upload="updateFile"
                  class="ck-editor__font"
                  data-qe-id="about_edit_dialog_ckEditor">
              </ck-editor>
            </v-flex>
          </v-layout>
        </v-container>
        <status-bar :action="savePostAction"></status-bar>
      </v-card-text>
      <v-flex text-xs-right>
        <v-btn
            class="primary_btn transparent"
            data-qe-id="about_edit_dialog_cancel_btn"
            flat
            @click="resetAboutMessage">
          {{ appCommonConstants.CANCEL }}
        </v-btn>
        <v-btn
            class="primary_btn"
            dark
            data-qe-id="about_edit_dialog_save_btn"
            @click="saveAboutMessage">
          {{ appCommonConstants.SAVE }}
        </v-btn>
      </v-flex>

    </v-card>
  </div>
</template>

<script>
import { communityCommonConstant } from "../communityCommon.constant";
import { appCommonConstants, routerNames } from "../../appCommon.constants";
import { mapActions, mapState } from "vuex";
import { storeAction } from "../../../store/storeActions.constant";
import CkEditor from "../../CkEditor/CkEditor";
import {
  getUploadedFileBase64,
  inputFilterForImageFile,
} from "../../../common/utils/fileUploader";
import FileUpload from "vue-upload-component";
import StatusBar from "../../StatusBar/StatusBar";
import { getRandomId } from '../../../common/utils/utils';
import { ckEditorType } from "../../../plugins/CkEditor/ckEditorTypes.config";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "EditAbout",
  components: {
    StatusBar,
    CkEditor,
    FileUpload,
  },
  props: {
    chapterAbout: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.newAboutMessage = cloneDeep(this.chapterAbout);
    this.files = [];
  },
  data() {
    return {
      editContainerShown: false,
      communityCommonConstant,
      ckEditorType,
      appCommonConstants,
      files: [],
      newAboutMessage: {},
      ckEditorId: getRandomId(),
    };
  },
  methods: {
    ...mapActions({
      createAboutMessage: `chapter/${storeAction.createAboutMessage}`,
      updateAboutMessage: `chapter/${storeAction.updateAboutMessage}`,
    }),
    validIdForUpdate(id) {
      return id && id !== '00000000-0000-0000-0000-000000000000';
    },
    toggleEditMode() {
      this.editContainerShown = !this.editContainerShown;
      this.$emit("editToggled", this.editContainerShown);
    },
    showEditContainer() {
      this.toggleEditMode();
    },
    resetAboutMessage() {
      this.newAboutMessage = cloneDeep(this.chapterAbout);
      this.files = [];
      this.toggleEditMode();
    },
    async saveAboutMessage() {
      const {
        id,
        message,
        aboutMessageImage,
        preserveExisitngAboutMessageImage,
      } = this.newAboutMessage;

      const aboutMessageSaveObj = {
        id,
        message,
        aboutMessageImage,
        preserveExisitngAboutMessageImage,
        communityId: this.$route.params.communityId,
      };

      console.log("save", aboutMessageSaveObj);

      if (this.validIdForUpdate(this.newAboutMessage.id)) {
        await this.updateAboutMessage(aboutMessageSaveObj);
      } else {
        await this.createAboutMessage(aboutMessageSaveObj);
      }

      this.toggleEditMode();
    },
    inputFilterForImageFile,
    updateFile(files) {
      if (files && files.length) {
        this.files = files;
        this.newAboutMessage.preserveExisitngAboutMessageImage = false;
        this.newAboutMessage.aboutMessageImage = {
          ...this.newAboutMessage.aboutMessageImage,
          url: this.files[0] && this.files[0].url ? this.files[0].url : "",
        };
        const { file } = this.files[0];
        getUploadedFileBase64(file).then((customJsonFile) => {
          //customJsonFile is your newly constructed file.
          if (customJsonFile) {
            this.newAboutMessage.aboutMessageImage = {
              data: customJsonFile.base64StringFile,
              contentType: customJsonFile.fileType,
            };
          } else {
            throw new Error("File not loaded.");
          }
        });
      }
    },

    removePostImage() {
      this.newAboutMessage.aboutMessageImage = {};
      this.newAboutMessage.preserveExisitngAboutMessageImage = false;
      this.files = [];
    },
  },
  computed: {
    imageUrl() {
      /*eslint-disable-next-line no-nested-ternary*/
      return (this.files.length && this.files[0].url) ?
          this.files[0].url :
          (
              this.newAboutMessage.aboutMessageImage &&
              this.newAboutMessage.aboutMessageImage.url &&
              this.newAboutMessage.aboutMessageImage.url.includes('communityaboutimage')
          ) ?
              this.newAboutMessage.aboutMessageImage.url :
              "";
    },
    ...mapState("actionState", ["actions"]),
    savePostAction() {
      return this.validIdForUpdate(this.chapterAbout.id) ?
          this.actions[storeAction.updateAboutMessage] :
          this.actions[storeAction.createAboutMessage];
    },
    addBtnMessage() {
      const messages = this.communityCommonConstant.chairMessage;
      switch (this.$route.name) {
        case routerNames.CHAPTER:
          return messages.ADD_SOMETHING_ABOUT_THIS_CHAPTER;
        case routerNames.REGION:
          return messages.ADD_SOMETHING_ABOUT_THIS_REGION;
        case routerNames.FORUM:
          return messages.ADD_SOMETHING_ABOUT_THIS_FORUM;
        case routerNames.NETWORK:
          return messages.ADD_SOMETHING_ABOUT_THIS_NETWORK;
        case routerNames.GROUP:
          return messages.ADD_SOMETHING_ABOUT_THIS_GROUP;
        case routerNames.BUSINESSES:
          return messages.ADD_SOMETHING_ABOUT_THIS_BUSINESS;
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/_colors.scss";
@import "../../../common/styles/_responsive.scss";
@import "../../../common/styles/_commonClasses.scss";

.about-chapter-edit {
  &__title {
    text-align: center;
    height: 100px;
    background-color: $ypo-dark-background-gray;

    color: $white;
    padding-top: 20px;
  }

  &__add-message {
    font-size: 11px;
  }

  &__image {
    &-frame {
      padding: 10px;
      padding-left: 23px;
      padding-right: 23px;
      max-height: 250px;
      overflow-y: auto;
    }

    &-container {
      position: relative;
    }

    &-remove {
      position: absolute !important;
      z-index: 10000;
      top: -10px;
      right: 0;
      transform: translate3d(50%, 0, 0);
      border: none;
      width: 45px;
      height: 45px;
      margin: 0px;
    }
  }

  &__chair-des {
    text-align: center;
    font-size: 15px !important;
    color: $ypo-blue;
  }

  .heading {
    height: 29px !important;
    width: 170px !important;
    color: rgba(84, 110, 122, 0.9) !important;
    font-family: Raleway, serif !important;
    font-size: 24px !important;
    letter-spacing: 0.17px !important;
    margin-top: 25px;
  }

  &__textarea {
    height: 100%;
    width: 100%;
    border-left: 1px solid $ypo-title-blue-gray;
    border-right: 1px solid $ypo-title-blue-gray;
    border-top: 1px solid $ypo-title-blue-gray;
    border-radius: 4px;
    padding: 8px;
  }

  &__img-format {
    border-radius: 50% !important;
    height: 96px;
    width: 96px;
    margin-top: 4px;
    border: 5px solid $ypo-title-blue-gray;
  }

  &__save_btn {
    border: 1px solid #979797 !important;
    border-radius: 4px;
    background-color: $ypo-blue !important;
    font-family: Gentona, Arial, Helvetica, sans-serif !important;
    font-size: 14.44px !important;
    font-weight: bold !important;
    letter-spacing: 1.25px !important;
  }

  &__close_btn {
    border-radius: 4px !important;
    color: #222222 !important;
    font-family: Gentona, Arial, Helvetica, sans-serif !important;
    font-size: 15.44px !important;
    font-weight: 600 !important;
    letter-spacing: 1.25px !important;
    line-height: 16px !important;
    text-align: center !important;
  }

  .v-card__text {
    padding-top: 16px;
    font-size: 16px;
    color: rgb(102, 102, 102);
  }

  &__text-right {
    float: right;
  }

  &__color-Text {
    color: $ypo-blue;
    font-weight: bold;
    float: right;
  }

  &__color-light {
    font-weight: lighter;
    color: $ypo-duskblue;
    text-align: justify;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-top: 0px;
  }

  &__text-Position {
    font-weight: bold;
    text-overflow: ellipsis;
  }

  &__btn-align {
    margin-left: 370px;
    color: $ypo-blue;
    font-weight: bold;
  }

  &__padding-space {
    padding-bottom: 0;
  }

  &__font-format {
    font-weight: lighter;
    margin-top: 25px;
    font-size: 25px;
  }

  &__chapter-name {
    margin-top: 33px;
    text-align: center;
  }

  &__message-desc-border {
    border-bottom: 1px solid $ypo-text-border;
    margin-top: 35px;
  }

  &__padding-text-left {
    padding-left: 40px;
  }
}
</style>

<style lang="scss">
.about-chapter-edit {
  .photo-uploader__btn {
    padding: 0 5px 5px !important;
    height: 32px;
  }

  .cke_contents {
    height: 350px !important;
  }

  .ck-editor__image-upload {
    top: 30px;
  }
}
</style>
